import { render, staticRenderFns } from "./ConfirmationCard.vue?vue&type=template&id=70c98714&scoped=true&"
import script from "./ConfirmationCard.vue?vue&type=script&lang=js&"
export * from "./ConfirmationCard.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmationCard.vue?vue&type=style&index=0&id=70c98714&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c98714",
  null
  
)

export default component.exports